(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("chevrotain"), require("unorm"), require("tiny-emitter"));
	else if(typeof define === 'function' && define.amd)
		define("HyperFormula", ["chevrotain", "unorm", "tiny-emitter"], factory);
	else if(typeof exports === 'object')
		exports["HyperFormula"] = factory(require("chevrotain"), require("unorm"), require("tiny-emitter"));
	else
		root["HyperFormula"] = factory(root["chevrotain"], root["unorm"], root["TinyEmitter"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__12__, __WEBPACK_EXTERNAL_MODULE__30__, __WEBPACK_EXTERNAL_MODULE__98__) {
return 